import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import WelcomeScreen from './components/WelcomeScreen';
import QuizScreen from './components/QuizScreen';
import ResultScreen from './components/ResultScreen';
import { questions, personalityTypes } from './data/quizData';
import './App.css';

function App() {
  const [currentScreen, setCurrentScreen] = useState('welcome');
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null);

  const handleStartQuiz = () => {
    setCurrentScreen('quiz');
    setCurrentQuestion(0);
    setAnswers([]);
  };

  const handleAnswerSelect = (answerType) => {
    const newAnswers = [...answers, answerType];
    setAnswers(newAnswers);

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      calculateResult(newAnswers);
    }
  };

  const calculateResult = (allAnswers) => {
    const counts = { A: 0, B: 0, C: 0 };
    
    allAnswers.forEach(answer => {
      counts[answer]++;
    });

    let resultType;
    if (counts.A >= counts.B && counts.A >= counts.C) {
      resultType = 'leader';
    } else if (counts.B >= counts.C) {
      resultType = 'thinker';
    } else {
      resultType = 'calm';
    }

    setResult(personalityTypes[resultType]);
    setCurrentScreen('result');
  };

  const handleRestartQuiz = () => {
    setCurrentScreen('welcome');
    setCurrentQuestion(0);
    setAnswers([]);
    setResult(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-400 via-pink-500 to-red-500">
      <AnimatePresence mode="wait">
        {currentScreen === 'welcome' && (
          <WelcomeScreen key="welcome" onStart={handleStartQuiz} />
        )}
        
        {currentScreen === 'quiz' && (
          <QuizScreen 
            key="quiz"
            question={questions[currentQuestion]}
            questionNumber={currentQuestion + 1}
            totalQuestions={questions.length}
            onAnswerSelect={handleAnswerSelect}
          />
        )}
        
        {currentScreen === 'result' && (
          <ResultScreen 
            key="result"
            result={result}
            onRestart={handleRestartQuiz}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;